import _ from 'lodash';
import {
    FETCH_AI_AGENT_COMMANDS,
    CLEAN_AI_AGENT_COMMANDS,
} from './types';
import { request, __ } from '../functions';

export const fetchAiAgentCommands = (screen, ai_agent_id, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-agent-commands/index/${ai_agent_id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_AGENT_COMMANDS, payload: data });
    });
};

export const cleanAiAgentCommands = () => ({ type: CLEAN_AI_AGENT_COMMANDS });
